// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import TextFormField, {
    TextFormFieldProps,
    TextFormFieldPresentationProps,
} from "@store/Library/Components/FormField/TextFormField";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";

export const firstNameFormFieldLabelKey = "First Name";

export interface FirstNameFormFieldPresentationProps extends ExpandStyles<FirstNameFormFieldStyles> {}

export interface FirstNameFormFieldProps
    extends Omit<TextFormFieldProps, keyof TextFormFieldPresentationProps>,
        FirstNameFormFieldPresentationProps {
    prefill?: boolean;
}

export interface FirstNameFormFieldStyles {
    textFormField?: TextFormFieldPresentationProps;
}

export const firstNameFormFieldStyles: FirstNameFormFieldStyles = {};

const FirstNameFormField: FC<FirstNameFormFieldProps> = ({
    extendedStyles,
    overridedStyles,
    prefill,
    prefillValue,
    ...textFormFieldProps
}) => {
    const styles = useExpandProps(firstNameFormFieldStyles, extendedStyles, overridedStyles);
    const session = useAppSelector(state => state.context.session);

    return (
        <TextFormField
            {...styles.textFormField}
            label={translate(`${firstNameFormFieldLabelKey}`)}
            {...textFormFieldProps}
            prefillValue={prefill ? session.firstName : prefillValue}
        />
    );
};

export default FirstNameFormField;
